// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__L3JvE","containerItemsCenter":"Skeleton_containerItemsCenter__3LFct"};